import { createAuditEntry } from "../../../domain/entities";

export const createAuditRecord = ({
  entityType,
  entityId,
  operation,
  actorId,
  revision,
  summary,
  payload,
}) =>
  createAuditEntry({
    entityType,
    entityId,
    operation,
    actorId,
    revision,
    summary,
    payload,
  });
